import React from 'react';
import { Wrapper } from '../Wrapper';
import { SimpleHeadlineProps } from './SimpleHeadlineBase';

const SimpleHeadlineBase = React.lazy(() => import('./SimpleHeadlineBase'));

export const SimpleHeadline = Wrapper((p: SimpleHeadlineProps): JSX.Element => {
    return (
        <React.Suspense fallback={null}>
            <SimpleHeadlineBase {...p} />
        </React.Suspense>
    );
}, 'simpleHeadline');
